import React from "react";

import { TestUniformPageProps } from "../../../../pages/test-uniform/test-uniform-page";
import { UniformWrapper } from "../../../../uniform/uniform-wrapper";

export const TestUniformPageTemplate: React.FC<TestUniformPageProps> = ({
    composition,
    isUniformPlayground
}) => {
    return (
        <UniformWrapper
            composition={composition}
            isUniformPlayground={isUniformPlayground}
        />
    );
};
